import { ValidationObserver, ValidationProvider } from "vee-validate";
import { ValidationRules } from "@/utils/validation-rules";
import * as firebase from "firebase";
export default {
  name: "RequestPOAPriceDlg",
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data() {
    return {
      dialog: false,
      price: 1,
    }
  },
  props: {
    request: {
      type: Object
    }
  },
  computed: {
    rules() {
      return {
        price: [ValidationRules.required, ValidationRules.positiveNumber, value => /^[1-9][0-9]*$/.test(value) || 'Only integers greater than 0 are allowed'],
      }
    },
    facilityCurrency() {
      return this.$store.getters.facilityCurrency;
    },
  },
  methods: {
    open() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    async savePrice() {
      const price = Number(this.price);
      if(price > 0) {
        await this.setPoaPrice(price)
          .then(() => {
            this.$toast.open({message: this.$t("ViewService.EnterCostForServiceSuccess"), type: "success"});
          }).catch((err) => {
            this.$toast.open({message: this.$t("GeneralTranslations.UnhandledError"), type: "error"});
            console.log("Error: ", err.message)
          }).finally(() => {
            this.close();
          })
      }
    },
    async setPoaPrice(value) {
      await this.$store.dispatch("updateAdditionalServiceRequest", {
        ...this.request,
        paymentCost: String(value),
        priceSetBy: this.$store.state.authModule.user.name
      });

      await this.$store.dispatch(
        "getAdditionalServiceRequest",
        this.$route.params.id
      );

      const subscribeRequestApprovals = await firebase
        .firestore()
        .collection("additionalServiceRequestApprovals")
        .where("facilityId", "==", this.$store.state.authModule.currentFacility)
        .orderBy('createdDateTime', 'asc')
        .limitToLast(5)
        .onSnapshot(snapshot => {
          snapshot.docChanges().forEach(change => {
            const document = change.doc.data();
            if (document.serviceRequestId === this.$route.params.id) {
              this.$store.dispatch(
                "getAdditionalServiceApprovals",
                this.$route.params.id
              ).finally(() => {
                setTimeout(() => {
                  subscribeRequestApprovals()
                }, 500)
              })
            }
          });
        })
    },
  },
}